'use client';
import React from 'react';
import Image from 'next/image';
import HIHButton from '@/components/base/HIHButton';
import { useRouter } from 'next/navigation';
import ErrorPageTracking from '@/components/base/ErrorPageTracking';
import { trackErrorPageHomeClick } from '@/utils/matomo';
import layoutStyles from '@/styles/section-layouts.module.scss';
import styles from './NotFound.module.scss';

export default function NotFound() {
  const router = useRouter();
  return (
    <div className={[layoutStyles.containerContent, styles.wrapper].join(' ')}>
      <ErrorPageTracking errorType="404" />
      <div className={styles.inner}>
        <div className={styles.imageCol}>
          <Image
            src="/images/404.png"
            alt="Fehler 404"
            width={510}
            height={494}
            className={styles.minWidthImage}
          />
        </div>

        <div className={styles.textCol}>
          <h2 className={styles.headline}>Oh no, hier gehts leider nicht weiter</h2>
          <p className={styles.copy}>
            Tut uns total Leid. Die Seite existiert nicht mehr. Als Trostpflaster zeigen
            wir dir eines unserer liebsten Hamburg-Bilder.
          </p>
          <div className={styles.buttons}>
            <HIHButton
              onClick={router.back}
              title="zurück"
              variant="secondary"
              showArrowBefore
              size="sm"
            />
            <HIHButton
              link="/"
              title="Zur Startseite"
              variant="outline"
              onClick={trackErrorPageHomeClick}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
